import { render, staticRenderFns } from "./model-match-renderer.vue?vue&type=template&id=7e38c5f1&lang=html"
import script from "./model-match-renderer.vue?vue&type=script&lang=js"
export * from "./model-match-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports